import { BGScratch, BGScratch_Thumb } from "../../../../../assets";
import { IMiniGameProps } from "../../../../../../typings/common";
import BonusGameCard from "./BonusGameCard";

function BGScratchGame({
  isSmall,
  onStartGame,
  config,
  miniGameData,
  playerLevel,
}: IMiniGameProps) {
  return (
    <BonusGameCard
      isSmall={isSmall}
      onStartGame={onStartGame}
      config={config}
      miniGameData={miniGameData}
      playerLevel={playerLevel}
      titleSource={BGScratch}
      thumbSource={BGScratch_Thumb}
      launchPath="/scratch/bowaPlayer.html"
      cooldownHours={8}
      freePlayTitleFontSize={13}
      infoPaddingVertical={4}
    />
  );
}

export default BGScratchGame;
